module.exports = __webpack_public_path__ + "img/case-logo-41.1ae7b268.png";